import type { Comment, EventSnapshot, MyEngagement } from '../types';
import { topicCatalog } from './topicCatalog';

const demoIds = [
  "33333333-3333-4333-8333-333333333333",
  "22222222-2222-4222-8222-222222222222",
  "11111111-1111-4111-8111-111111111111",
  "44444444-4444-4444-8444-444444444444",
  "66666666-6666-4666-8666-666666666666",
  "77777777-7777-4777-8777-777777777777",
  "88888888-8888-4888-8888-888888888888",
  "99999999-9999-4999-8999-999999999999",
  "aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa"
];

export const demoSnapshot: EventSnapshot = {
  settings: {
    eventTitle: 'Panther Meeting 2026',
    currentTopicId: null,
    currentTopicChangedAt: null,
    audienceFollowEnabled: true,
    audienceBrowsingEnabled: false,
    interactionGeneration: 0,
    commentsEnabled: true,
    eventEnabled: true,
  },
  topics: topicCatalog.map((topic, index) => ({
    title: topic.title,
    presenter: topic.presenter,
    discussionQuestion: topic.discussionQuestion,
    discussionOptions: topic.discussionOptions,
    id: demoIds[index],
    description: '',
    displayOrder: index + 1,
    status: 'open',
    isPublished: true,
    likeCount: 0,
    flowerCount: 0,
    commentCount: 0,
  })),
};

export const demoComments: Comment[] = [];
export const demoEngagement: MyEngagement = {
  topicId: demoSnapshot.topics[0].id,
  liked: false,
  flowerCount: 0,
};
